import { UsedInEmailTemplates } from "../../../util/enums";
import { EntityContext } from "./index";

/**
 * Maps UsedInEmailTemplates to backend notification type
 */
export const getTypeFromUsedIn = (usedIn: UsedInEmailTemplates): 'Order' | 'Shipment' | 'Quote' | 'Invoice' => {
  // The enum values already match the backend types
  return usedIn as 'Order' | 'Shipment' | 'Quote' | 'Invoice';
};

/**
 * Maps UsedInEmailTemplates to entity type
 */
export const getEntityTypeFromUsedIn = (usedIn: UsedInEmailTemplates): 'quote' | 'order' | 'shipment' | 'invoice' => {
  const mapping: Record<UsedInEmailTemplates, 'quote' | 'order' | 'shipment' | 'invoice'> = {
    [UsedInEmailTemplates.QUOTES]: 'quote',
    [UsedInEmailTemplates.ORDERS]: 'order',
    [UsedInEmailTemplates.SHIPMENTS]: 'shipment',
  };
  return mapping[usedIn];
};

/**
 * Gets the backend notification type from entity context
 */
export const getTypeFromEntityContext = (context: EntityContext): 'Order' | 'Shipment' | 'Quote' | 'Invoice' => {
  switch (context.entityType) {
    case 'quote':
      return 'Quote';
    case 'order':
      return 'Order';
    case 'shipment':
      return 'Shipment';
    case 'invoice':
      return 'Invoice';
    default:
      return 'Order';
  }
};
